export const RANDOM_THOUGHTS = {
  id: 'thoughts',
  orderNumber: 1,
  title: 'Random thoughts 💭',
  content: '',
};
